module.exports = {
  "title": "Integrations",
  "integration_expired": "Your integration session has been expired, Please re-authenticate to access",
  "add_fields": "Add fields",
  "re_authenticate": "Please re-authenticate.",
  "primary_configuration": "Primary configuration",
  "admin_configuration": "Admin configuration",
  "override_configuration": "Override configuration",
  "show_override": "Show override configuration",
  "instance_name": "Instance Name",
  "shared_fields": "Shared fields",
  "sync_events": "Sync Events",
  "sync_deals": "Sync Deals",
  "event_key": "Event Key",
  "loading_shared_fields": "loading shared fields",
  "loading_configuration": "loading configuration",
  "wish_to_continue": "Do you wish to continue?",
  "select_field": "Select Field",
  "view_list_values": "View list values",
  "oops_error": "Oops Error!",
  "integration": "Integration",
  "learn_more": "Learn more:",
  "conflict":{
    "title": "Well, we have a conflict!",
    "sub_text": 'Looks like your account is already connected to a {name} service - "{activatedName}". Please de-activate {integrationName} to use "{serviceName}" '
  },
  "filters":{
    "title": "Filter",
    "all": "All",
    "email": "Email",
    "CRM": "CRM",
    "messaging": "Messaging",
    "marketing_automation": "Marketing Automation",
    "analytics": "Analytics",
    "notifications": "Notifications",
    "social": "Social",
  },
  "configs": {
    "create_lead": "Create a Lead",
    "sync_deals": "Sync Deals",
    "view_asset": "Contact/Lead views an asset",
    "view_collection": "Contact/Lead views a collection",
    "reshare_collection": "Contact/Lead reshares a collection",
    "download_asset": "Contact/Lead downloads an asset",
    "opens_email": "Contact/Lead opens an email",
    "visits_link": "Contact/Lead visits a link",
  },
  "actions": {
    "on": "on",
    "off": "off",
    "deactivate": "Deactivate",
    "deactivating": "Deactivating",
    "activate": "Activate",
    "activated": "Activated",
    "activating": "Activating",
    "re_authenticate": "Re-authenticate",
    "re_authenticating": "Re-authenticating",
    "synchronize": "Synchronize",
    "synchronizing": "Synchronizing",
    "authenticate": "Authenticate",
    "connect_now": "Connect now",
    "authenticating": "Authenticating",
    "show_onboarding_label": "Here is how the integration works"
  },
  "integrations":
  {
    "linkedIn":{
      "name": "LinkedIn",
      "description": "Integrate with LinkedIn to access and share interactive content"
    },
    "docusign": {
      "name": "DocuSign",
      "description": "Integrate with DocuSign to streamline secure eSignature workflows for your content and deals."
    },
    "cleverstory":{
      "name": "Cleverstory",
      "description": "Integrate with Cleverstory to access and share interactive content"
    },
    "gmail": {
      "name": "Gmail",
      "description": "Integrate with Gmail to share content from your Gmail profile",
    },
    "outlook": {
      "name": "Outlook",
      "description": "Integrate with Outlook to share content from your Outlook profile",
    },
    "smtp": {
      "name": "SMTP",
      "description": "Integrate with any SMTP to share content from your SMTP service provider",
    },
    "eloqua": {
      "name": "Eloqua",
      "description": "Integrate with Eloqua to sync events across contacts",
    },
    "salesforce": {
      "name": "Salesforce",
      "description": "Integrate with Salesforce to sync events across leads & contacts",
    },
    "salesforce_sandbox": {
      "name": "Salesforce Sandbox",
      "description": "Integrate with Salesforce to sync events across leads & contacts.",
    },
    "freshsales": {
      "name": "Freshsales",
      "description": "Integrate with Freshsales to sync events across leads & contacts",
    },
    "hubspot": {
      "name": "HubSpot",
      "description": "Integrate with HubSpot to sync events across contacts",
    },
    "suitecrm": {
      "name": "Suitecrm",
      "description": "Integrate with SuiteCRM to sync events across leads & contacts",
    },
    "pipedrive": {
      "name": "Pipedrive",
      "description": "Integrate with Pipedrive to sync events across contacts",
    },
    "klenty": {
      "name": "Klenty",
      "description": "Integrate with Klenty to sync personalized URLs for your leads",
    },
    "outreach": {
      "name": "Outreach",
      "description": "Integrate with Outreach to sync personalized URLs for your prospects",
    },
    "intercom": {
      "name": "Intercom",
      "description": "Integrate with Intercom to manage conversations with customers",
    },
    "freshchat": {
      "name": "Freshchat",
      "description": "Integrate with Freshchat to manage conversations with customers",
    },
    "drift": {
      "name": "Drift",
      "description": "Integrate with Driftchat to manage conversations with customers",
    },
    "google_analytics": {
      "name": "Google Analytics",
      "description": "Integrate with Google Analytics (Universal Analytics) to track shared links (ineffective from July 1, 2023)",
    },
    "google_analytics_v4": {
      "name": "Google Analytics 4",
      "description": "Integrate with Google Analytics 4 to track shared links",
    },
    "google_tag_manager": {
      "name": "Google Tag Manager",
      "description": "Integrate with Google to track Tag-level analytics",
    },
    "six_sense": {
      "name": "Six Sense",
      "description": "Integrate with Six Sense to track analytics",
    },
    "zoho": {
      "name": "Zoho",
      "description": "Integrate with Zoho to sync events across leads & contacts",
    },
    "ms_dynamics": {
      "name": "Microsoft Dynamics",
      "description": "Integrate with Microsoft Dynamics to sync events across leads & contacts",
    },
    "salesloft": {
      "name": "Salesloft",
      "description": "Integrate with Salesloft to sync events across leads & contacts",
    },
    "allocadia": {
      "name": "Allocadia",
      "description": "Integrate with Allocadia to create a new offer",
    },
    "marketo": {
      "name": "Marketo",
      "description": "Integrate with Marketo to sync events across leads & contacts",
    },
    "slack": {
      "name": "Slack",
      "description": "Integrate with slack to send user notifications",
    },
    "external_script": {
      "name": "External Script",
      "description": "Gives you the ability to add custom scripts to embed / integrate /design specific inputs into Fliteview",
    },
    "pardot": {
      "name": "Pardot",
      "description": "Integrate with Pardot to sync events across leads & contacts",
    },
    "netsuite": {
      "name": "Netsuite",
      "description": "Integrate with netsuite to sync events across leads & contacts",
    },
    "zoom": {
      "name": "Zoom",
      "description": "Integrate with your zoom account. This integration helps you share your zoom recordings links as video via Paperflite.",
    },
    "teams": {
      "name": "Microsoft Teams",
      "description": "Integrate with your Microsoft Teams account. This integration helps you share your Teams recordings links as video via Paperflite.",
    },
    "fireflies": {
      "name": "Fireflies",
      "description": "Integrate with Fireflies to upload recording videos directly with shared fire flies url",
    },
  },
  "cleverstory": {
    "title": "Cleverstory", 
    "sub_text": "Connect CleverStory to empower your sales team with interactive content, personalized experiences, and actionable buyer insights.",
    "header": "Welcome to Paperflite’s integration with Cleverstory! Enable your sales reps to engage buyers and close deals faster, with personalized interactive content experiences",
    "storyboards": "Storyboards",
    "storyboard": "Storyboard",
    "no_workspaces": "No workspace found",
    "no_storyboards": "No storyboards found",
    "empty_message": "Oops, looks like you don't have access to this integration. Please reach out to your admin to get access to the integration",
    "deactivate": {
        "title": "Cleverstory",
        "sub_text": "Deactivating the Paperflite-Cleverstory integration?",
        "description":  "Deactivating {name} will remove {assetsCount} assets. This can't be undone. Are you sure you want to proceed ?",
      }, 
    "activate" : {
       "title" : "Cleverstory",
       "description": "Activate {name} to access and leverage your interactive content within Paperflite ?"
    },
    "access" : {
       "title" : "Oops, looks like you don't have access to this integration.",
       "description":  "Please reach out to your admin to get access to the integration",
    }
  },
  "gmail": {
    "title": "Gmail",
    "sub_text": "With this integration, every email sent from Paperflite's Quicksend/Compose will seamlessly synchronize with your Gmail account.",
    "active": {
      "title": "Gmail integration is currently active",
      "email": "for email account",
    },
    "activate": {
      "title": "Log into your Gmail account",
      "sub_text": "A secure gmail account authorization window will <br/> open when you click authenticate below"
    },
    "expired": {
      "title": "Your Gmail integration has expired.",
      "sub_text": "Please re-authenticate."
    },
    "sliders": {
      "deactivate": {
        "title": "deactivating",
        "subtext": "Upon deactivation, your emails will no longer be sent from email id: {email}. There will be no other changes to your account. You will still be able to share content from Paperflite’s default email-id.",
        "description": "Do you wish to continue?"
      },
    }
  },
  "zoom": {
    "title": "Zoom",
    "sub_text": "Integrate with Zoom to capture meeting transcripts, evaluate rep performance, and push coaching insights to your integrated CRM.",
    "active": {
      "title": "Zoom integration is currently active",
      "email": "for email account",
    },
    "activate": {
      "title": "Log into your Zoom account",
      "sub_text": "A secure Zoom account authorization window will <br/> open when you click authenticate below"
    },
    "expired": {
      "title": "Your Zoom integration has expired.",
      "sub_text": "Please re-authenticate."
    },
    "sliders": {
      "deactivate": {
        "title": "deactivating",
        "subtext": "Upon deactivation, your Zoom will no longer be sent from email id: {email}. There will be no other changes to your account. You will still be able to share content from Paperflite’s default email-id.",
        "description": "Do you wish to continue?"
      },
    }
  },
  "teams": {
    "title": "Microsoft Teams",
    "sub_text": "Integrate with Microsoft Teams to capture meeting transcripts, evaluate rep performance, and push coaching insights to your integrated CRM.",
    "active": {
      "title": "Teams integration is currently active",
      "email": "for email account",
    },
    "activate": {
      "title": "Log into your Teams account",
      "sub_text": "A secure Teams account authorization window will <br/> open when you click authenticate below"
    },
    "expired": {
      "title": "Your Teams integration has expired.",
      "sub_text": "Please re-authenticate."
    },
    "sliders": {
      "deactivate": {
        "title": "deactivating",
        "sub_text": "Upon deactivation, your Teams will no longer be sent from email id: {email}. There will be no other changes to your account. You will still be able to share content from Paperflite’s default email-id.",
        "subtext": "Upon deactivation, your Teams will no longer be sent from email id: {email}. There will be no other changes to your account. You will still be able to share content from Paperflite’s default email-id.",
        "description": "Do you wish to continue?"
      },
    }
  },
  "fireflies": {
    "title": "Fireflies",
    "sub_text": "Integrate with Fireflies to capture meeting transcripts, evaluate rep performance, and push coaching insights to your integrated CRM.",
    "active": {
      "title": "Fireflies integration is currently active",
      "email": "for email account",
    },
    "activate": {
      "title": "Log into your Fireflies account",
      "sub_text": "A secure Fireflies account authorization window will <br/> open when you click authenticate below",
      "api_key": "API KEY",
      "placeholder": "Enter your api key",
      "error": "Please provide a valid apiKey"
    },
    "expired": {
      "title": "Your Fireflies integration has expired.",
      "sub_text": "Please re-authenticate."
    },
    "sliders": {
      "deactivate": {
        "title": "deactivating",
        "subtext": "Upon deactivation, your Fireflies will no longer be sent from email id: {email}. There will be no other changes to your account. You will still be able to share content from Paperflite’s default email-id.",
        "description": "Do you wish to continue?"
      },
    }
  },
  "outlook": {
    "title": "Outlook",
    "sub_text": "With this integration, every email sent from Paperflite’s Quicksend/Compose will seamlessly synchronize with your Outlook account.",
    "activate": {
      "title": "Log into your Outlook account",
      "sub_text": "A secure outlook account authorization window will <br/> open when you click authenticate below"
    },
    "expired": {
      "title": "Your Outlook integration has expired.",
      "re_authenticate": "Please re-authenticate."
    },
    "active": {
      "title": "Outlook integration is currently active",
      "for_email": "for email account"
    },
    "deactivate_slider": {
      "title": "Outlook",
      "sub_text": "Upon deactivation, your emails will no longer be sent from email id: {email}. There will be no other changes to your account. You will still be able to share content from Paperflite’s default email-id."
    }
  },
  "smtp": {
    "title": "SMTP",
    "sub_text": "Integrate your SMTP services Paperflite account soyou can send emails from your email provider and have a record in your sent items.",
    "description": "Simple Mail Transfer Protocol is an Internet standard for email transmission. SMTP moves your email on and across networks (ie from Paperflite to your inbox).",
    "loading": "Loading SMTP configuration",
    "deactivate_slider": "Upon deactivation, mails will no longer be sent from your email id:",
    "activate": {
      "host_name": "Host name",
      "port": "Port",
      "username": "User name",
      "password": "Password",
      "from_address": "From address",
      "display_name": "Display name",
      "ssl": "Use TLS/SSL to connect (recommended)",
      "starttls": "Use STARTTLS to connect"
    },
    "placeholders": {
      "host_name": "Enter your host name",
      "port": "Enter your SMTP port",
      "username": "Enter your username",
      "password": "Enter your password",
      "from_address": "Enter your from address",
      "display_name": "Enter your display name"
    },
    "error_messages": {
      "host": "Please provide a valid host name",
      "username": "Please provide a valid user name",
      "display_name": "Please provide a valid display name",
      "port": "Please provide a valid port number",
      "password": "Please provide a valid password",
      "from_address": "Please provide a valid from address",
    }
  },
  "eloqua": {
    "title": "eloqua",
    "sub_text": "Integrate Eloqua to sync events across contacts",
    "wrong_api_key": "The API key you entered was incorrect, Please re-authenticate to access",
    "select_field": "Select field",
    "select_segment": "Select segment",
    "select_object": "Select object",
    "sync": {
      "title": "Synchronisation Status",
      "not_synced": "You are yet to synchronise leads & contacts data with eloqua",
      "synced": "Synchronising since",
      "last_synced": "You last synchronised on",
    },
    "activate": {
      "title": "Log in to your Eloqua account",
      "sub_text": "Please provide a user account with global access"
    },
    "configuration": {
      "title": "Configure your Eloqua account",
      "sub_text": "Choose & configure the entities to sync with Paperflite",
      "auto_create_field": "Auto create new custom field(Paperflite Link)",
      "auto_create_object": "Auto create new custom objects",
      "select_custom_objects": "Select custom objects for",
      "entites": {
        "title": "Entities",
        "sub_text": "Configuration for the entities to sync with paperflite"
      },
      "contact_segment": {
        "title": "Contact Segment",
        "sub_text": "Choose a segment to sync with paperflite"
      },
      "contact_field": {
        "title": "Contact Field",
        "sub_text": "Create/Choose a field to update the unique customer url"
      },
      "custom_objects": {
        "title": "Custom Objects",
        "sub_text": "Configuration for the custom objects to sync with paperflite"
      },
      "contact_object": {
        "title": "Contact Object",
        "sub_text": "Choose a custom object to sync contact based analytics from paperflite"
      },
      "asset_object": {
        "title": "Asset Object",
        "sub_text": "Choose a custom object to sync asset based analytics from paperflite"
      },
      "collection_object": {
        "title": "Collection Object",
        "sub_text": "Choose a custom object to sync collection based analytics from paperflite"
      }
    }
  },
  "salesforce": {
    "title": "Salesforce",
    "sub_text": "Integrating Paperflite with Salesforce enables sales reps to nurture their prospects at every stage of the buyer's journey with contextual content. It helps sales reps know how their prospects are engaging with their content, i.e., number of views, downloads, re-shares etc.",
    "active": "Salesforce integration is currently active for this email account.",
    "active_instance": "Salesforce integration is currently active for this instance.",
    "secondary_active": "You are currently connected to {0}. In order to override your account, please",
    "config": "Configuration for the events to publish to Salesforce",
    "custom_fields": "Make custom fields from Salesforce for an opportunity available  within Paperflite",
    "update_fields_success": "Salesforce shared fields updated successfully",
    "loading":{
      "config": "Loading salesforce configuration",
      "override": "Loading override configuration",
    },
    "authenticate": {
      "title": "Log into your Salesforce account",
      "sub_text": "A secure Salesforce account authorization window will <br/> open when you click authenticate below"
    },
    "error_messages": {
      "instance_url": "Please provide a valid instance url",
      "primary_expired": {
        "title": "Log into your Salesforce account",
        "sub_text": "Your authentication to Salesforce has expired and needs to be renewed.",
        "non_admin":"Please contact your admin to renew authentication",
        "description": "The Salesforce Admin integration with {0} has expired. Please reach out to the Admin to reauthenticate the integration."
      }, 
      "expired": "The authentication to Salesforce has expired for the Admin and needs to be re-authenticated.",
      "click_here": "Click here",
      "to_authenticate": "To authenticate",
      "session_expired_secondary": "Your overridden configuration has expired. Please {0} to re-authenticate. Note: Until you re-authenticate, the integration will function as per the admin’s configuration.",
      "session_expired": "Your session has expired. You are currently connected to {0}. In order to override your account, please {1}"
    }, 
    "sliders":{
      "deactivate": {
        "title": "Salesforce",
        "sub_text": "Deactivating the Paperflite-Salesforce integration?",
        "description": {
          "title" : "1. This will impact all users across {count} accounts utilising this integration",
          "shared_field": "2. Oh, and those synchronized Shared Fields and Events? They'll be gone too."
        }
      },
      "override": {
        "title": "change override configuration",
        "sub_text": "Do you wish to modify override configuration?"
      },
      "change_admin_config": {
        "title": "Change admin configuration",
        "sub_text": "Do you wish to modify primary configuration?",
        "note": "Note: Just a heads up, any changes made to the Primary Configuration will apply to all users on the account."
      },
      "remove_secondary": {
        "title": "Remove secondary configuration",
        "sub_text": "Do you wish to remove secondary configuration?"
      }
    },
    "empty_message":{
      "title": "Halt! Road closed ahead.",
      "sub_text": "You don't have access to Salesforce yet. Get in touch with your Paperflite administrator to integrate with Salesforce."
    }  
  },
  "salesforce_sandbox": {
    "title": "Salesforce Sandbox",
    "sub_text": "Integrating Paperflite with Salesforce enables sales reps to nurture their prospects at every stage of the buyer's journey with contextual content. It helps sales reps know how their prospects are engaging with their content, i.e., number of views, downloads, re-shares etc.",
    "active": "Salesforce integration is currently active for this email account.",
    "active_instance": "Salesforce integration is currently active for this instance.",
    "secondary_active": "You are currently connected to {0}. In order to override your account, please",
    "config": "Configuration for the events to publish to Salesforce",
    "custom_fields": "Make custom fields from Salesforce for an opportunity available  within Paperflite",
    "update_fields_success": "Salesforce shared fields updated successfully",
    "loading":{
      "config": "Loading salesforce sandbox configuration",
      "override": "Loading override configuration",
    },
    "authenticate": {
      "title": "Log into your Salesforce account",
      "sub_text": "A secure Salesforce account authorization window will <br/> open when you click authenticate below"
    },
    "error_messages": {
      "instance_url": "Please provide a valid instance url",
      "primary_expired": {
        "title": "Log into your Salesforce account",
        "sub_text": "Your authentication to Salesforce has expired and needs to be renewed.",
        "non_admin":"Please contact your admin to renew authentication",
        "description": "The Salesforce Admin integration with {0} has expired. Please reach out to the Admin to reauthenticate the integration."
      }, 
      "expired": "The authentication to Salesforce has expired for the Admin and needs to be re-authenticated.",
      "click_here": "Click here",
      "to_authenticate": "To authenticate",
      "session_expired_secondary": "Your overridden configuration has expired. Please {0} to re-authenticate. Note: Until you re-authenticate, the integration will function as per the admin’s configuration.",
      "session_expired": "Your session has expired. You are currently connected to {0}. In order to override your account, please {1}"
    }, 
    "sliders":{
      "deactivate": {
        "title": "Salesforce",
        "sub_text": "Deactivating the Paperflite-Salesforce integration?",
        "description": {
          "title" : "1. This will impact all users across {count} accounts utilising this integration",
          "shared_field": "2. Oh, and those synchronized Shared Fields and Events? They'll be gone too."
        }
      },
      "override": {
        "title": "change override configuration",
        "sub_text": "Do you wish to modify override configuration?"
      },
      "change_admin_config": {
        "title": "Change admin configuration",
        "sub_text": "Do you wish to modify primary configuration?",
        "note": "Note: Just a heads up, any changes made to the Primary Configuration will apply to all users on the account."
      },
      "remove_secondary": {
        "title": "Remove secondary configuration",
        "sub_text": "Do you wish to remove secondary configuration?"
      }
    },
    "empty_message":{
      "title": "Halt! Road closed ahead.",
      "sub_text": "You don't have access to Salesforce yet. Get in touch with your Paperflite administrator to integrate with Salesforce."
    }  
  },
  "hubspot":{
    "title": "HubSpot",
    "sub_text": "Connecting HubSpot with Paperflite allows sales reps to provide superior content experience to prospects. It also allows for intelligence on how sales reps can customize the content to suit the buyer’s needs by providing detailed analytical insights into how the prospect is engaging with content shared.",
    "active": "HubSpot integration is currently active for this account.",
    "active_email": "HubSpot integration is currently active for this email account.",
    "secondary_active": "You are currently connected to {0}. In order to override your account, please {1}",
    "config": "Configuration for the events to publish to HubSpot",
    "authenticate": {
      "title": "Log into your HubSpot account",
      "sub_text": "A secure HubSpot account authorization window will <br/> open when you click authenticate below"
    },
    "custom_fields": "Make custom fields from Hubspot for an opportunity available  within Paperflite",
    "error_messages": {
      "instance_url": "Please provide a valid instance url",
      "primary_expired": {
        "title": "Log in to your HubSpot account",
        "sub_text": "Your authentication to HubSpot has expired and needs to be re-authenticated.",
        "non_admin":"Please contact your admin to renew authentication",
      }, 
      "expired": "The authentication to HubSpot has expired for the Admin and needs to be re-authenticated.",
      "click_here": "Click here",
      "to_authenticate": "To authenticate",
      "session_expired_secondary": "Your overridden configuration has expired. Please {0} to re-authenticate. Note: Until you re-authenticate, the integration will function as per the admin’s configuration.",
      "session_expired": "Your session has expired. You are currently connected to “{primaryEmail}”. In order to override your account, please {0}"
    },  
    "sliders":{
      "deactivate": {
        "title": "HubSpot",
        "sub_text": "Upon deactivation, analytics will not displayed in HubSpot.",
        "description": {
          "title" : "1. This will impact all users across {count} accounts utilising this integration",
          "shared_field": "2. Oh, and the events will be gone too."
        }
      }, 
      "override": {
        "title": "change override configuration",
        "sub_text": "Do you wish to modify override configuration?"
      }, 
      "change_admin_config": {
        "title": "Change admin configuration",
        "sub_text": "Do you wish to modify primary configuration?",
        "note": "Note: Just a heads up, any changes made to the Primary Configuration will apply to all users on the account."
      },
      "remove_secondary": {
        "title": "Remove secondary configuration",
        "sub_text": "Do you wish to remove secondary configuration?"
      }
    },
  },
  "freshsales": {
    "title": "Freshsales",
    "sub_text": "Integrate freshsales CRM to sync events across leads & contacts",
    "loading": "Loading freshsales configuration",
    "help_text": {
      "title": "Need help",
      "sub_text": "Here is how the integration works"
    },
    "details": {
      "domain_name": "Domain name",
      "api_key": "API key",
      "analytics_key": "Analytics key",
      "config": "Configuration for the events to publish to freshsales",
      "sub_texts": {
        "api_key": "To find your API key, Click your Profile picture and select Settings and click the API settings tab",
        "analytics_key": "To find your analytics key, Click on Settings and under Integrations, click the Freshsales for web. Copy the analytics key from one of the language library"
      },
      "placeholders": {
        "domain_name": "Enter your domain name",
        "api_key": "Enter your api key",
        "analytics_key": "Enter your analytics key",
      },
      "deactivate": {
        "title": "Freshsales",
        "sub_text": "Upon deactivation, analytics will not displayed in Freshsales."
      },
      "error_message": {
        "domain": "Please provide a valid domain name",
        "title": "Halt! Road closed ahead.",
        "no_access": "You don't have access to Freshsales yet. Get in touch with your Paperflite administrator to integrate with Freshsales."
      },
      "onboarding_page": {
        "title": "Integrating with Freshsales",
        "download": {
          "title": "Download Chrome Extension",
          "sub_text": "The Paperflite extension for Chrome. Log in with your Paperflite credentials.",
          "click_here": "Click here to Download",
          "chrome_extension": " Paperflite chrome extension"
        },
        "add_content": {
          "title": "Add Content from Paperflite",
          "sub_text": "Select the leads/contacts in Freshsales whom you want to mail.",
          "description": "Click on the Paperflite icon at the bottom of your mail to add all your content."
        },
        "view_analytics": {
          "title": "View Analytics",
          "sub_text": "Now, just sit back and watch the analytics load up. Still unsure about it?",
          "description": "Here's a {0} that makes it easier for you.",
          "steps": "step-by-step document"
        }


      }
    },
  },
  "suitecrm": {
    "title": "SuiteCRM",
    "sub_text": "Integrate suite CRM to sync events across leads &amp; contacts",
    "loading": "Loading configuration",
    "select_placeholder": "Select field",
    "sync": {
      "title": "Synchronisation Status",
      "not_synced": "You are yet to synchronise leads & contacts data with suitecrm CRM",
      "synced": "Synchronising since",
      "last_synced": "You last synchronised on",
    },
    "deactivate_slider": {
      "title": "Suitecrm",
      "sub_text": "Upon deactivation, analytics will not displayed in Suite CRM"
    },
    "configuration": {
      "title": "Configure your Suitecrm account",
      "sub_text": "Choose & configure the entities to sync with paperflite",
      "entites": {
        "title": "Entities",
        "sub_text": "Configuration for the entities to sync with paperflite"
      },
      "entitiy": {
        "title": "Entity",
        "sub_text": "Choose the entity to sync with paperflite"
      },
      "field": {
        "title": "Field",
        "sub_text": "Choose a field to update the unique customer url"
      },
      "events": {
        "title": "Events",
        "sub_text": "Configuration for the events to publish to suitecrm"
      },
      "view_asset": "Contact/Lead views an asset",
      "view_collection": "Contact/Lead views a collection",
      "reshare_collection": "Contact/Lead reshares a collection"


    },
    "error_messages": {
      "instance_url": "Please provide a valid suitecrm instance url",
      "username": "Please provide your username",
      "password": "Please provide your credentials",
    },
    "activate": {
      "title": "Log in to your SuiteCRM account",
      "sub_text": "Please provide a user account with global access",
      "instance_url": "Instance url",
      "username": "username",
      "password": "password",
    },
    "placeholders": {
      "instance_url": "Enter your CRM instance url",
      "username": "Enter your username",
      "password": "Enter your password",
    }

  },
  "pipedrive": {
    "title": "Pipedrive",
    "sub_text": "Our Pipedrive integration enables sales reps to track content across its entire journey and enables them with deeper insights into what works best. Pipedrive users can now bring any content from anywhere to launch campaigns, send emails, host events, and analyze user engagement - all without leaving their favorite CRM.",
    "loading": "Loading pipedrive configuration",
    "activate": {
      "title": "Log into your Pipedrive account",
      "sub_text": "A secure Pipedrive account authorization window will <br />open when you click authenticate below"
    },
    "deactivate_slider": {
      "title": "Pipedrive",
      "sub_text": "Upon deactivation, analytics will not displayed in Pipedrive."
    },
    "expired": {
      "title": "Your Pipedrive integration has expired.",
      "sub_text": "Please re-authenticate."
    },
    "configuration": {
      "domain_name": "Domain name",
      "active": "Pipedrive integration is currently active for this domain",
      "email_active": "Pipedrive integration is currently active for this email account",
      "sync_events": {
        "title": "Sync events",
        "sub_text": "Configuration for the events to publish to pipedrive",
        "events": {
          "asset_view": "Contact/Lead views an asset",
          "collection_view": "Contact/Lead views a collection",
          "collection_reshare": "Contact/Lead reshares a collection",
          "create_lead": "Create a lead",
          "download_asset": "Contact/Lead downloads an asset",
          "sync_deals": "Sync Deals"
        }
      },
      "empty_message": {
        "title": "Halt! Road closed ahead.",
        "sub_text": "You don't have access to Pipedrive yet. Get in touch with your Paperflite administrator to integrate with Pipedrive."
      }
    }
  },
  "klenty": {
    "title": "Klenty",
    "sub_text": "Integrate with your Klenty account using API keys. This integration will help provision personalized URLs for your leads. These URLs can then be used in your email templates for cadences via Klenty.",
    "deactive_slider": {
      "title": "Klenty",
      "sub_text": "Upon deactivation, analytics will not displayed in Klenty."
    },
    "activate": {
      "title": "Integrate your Klenty account",
      "sub_text": "Integrate with Klenty to sync personalized URLs for your leads",
      "username": "Username",
      "enter_api_key": "Enter your API key",
      "company_api_key": {
        "title": "Company API key",
        "sub_text": "Use the company API Key found in Settings - Company Settings. To include your team to integrate with paperflite"
      },
      "user_api_key": {
        "title": "User API key",
        "sub_text": "Use the API Key located in Settings - User Preferences."
      },
      "placeholder": {
        "username": "enter your klenty username",
      }
    },
    "error_messages": {
      "api_key": "Enter a valid api key",
      "username": "Enter a valid username",
    }
  },
  "outreach": {
    "title": "Outreach",
    "sub_text": "Our Outreach integration enables sales reps to track content across its entire journey and enables them with deeper insights into what works best.",
    "loading": "Loading outreach configuration",
    "authenticate": {
      "title": "Log into your Outreach account",
      "sub_text": "A secure Outreach account authorization window will <br/> open when you click authenticate below"
    },
    "configuration": {
      "active": "Outreach integration is currently active for this email account.",
      "sync_events": {
        "title": "Sync events",
        "sub_text": "Configuration for the events to publish to outreach",
        "events": {
          "asset_view": "Contact/Lead views an asset",
          "collection_view": "Contact/Lead views a collection",
          "collection_reshare": "Contact/Lead reshares a collection"
        },
      },
      "deactivate_slider": {
        "title": "Halt! Road closed ahead.",
        "sub_text": "You don't have access to outreach yet. Get in touch with your Paperflite administrator to integrate with Freshsales."
      }
    },
    "expired":{
      "title": "Your Outreach integration has expired.",
      "sub_text": "Please re-authenticate.",
    }
  },
  "intercom": {
    "title": "Intercom",
    "sub_text": "Integrate Intercom to manage conversations with customers",
    "deactivate_slider": {
      "title": "Intercom",
      "sub_text": "Upon deactivation, analytics will not displayed in Intercom."
    },
    "error_messages": {
      "app_id": "Please provide a valid appId name",
      "padding": "Please provide a valid  padding ex : (20)"
    },
    "activate": {
      "title": "Log in to your Intercom account",
      "sub_text": "Please provide a user account with global access",
      "app_id": "Intercom AppId",
      "placeholder": "Enter your Intercom AppId",
      "alignment": "Alignment",
      "right_down": "Right Down",
      "left_down": "Left Down",
      "horizontal_padding": "Horizontal padding",
      "vertical_padding": "Vertical padding"
    },
    "customization": " For more customizations at an account level, please",
    "advanced_settings": "click here for advanced settings."

  },
  "freshchat": {
    "title": "Freshchat",
    "sub_text": "Integrate Freshchat to manage conversations with customers",
    "deactivate_slider": {
      "title": "Freshchat",
      "sub_text": "Upon deactivation, analytics will not displayed in Freshchat."
    },
    "token_error": "Please provide a valid token name",
    "activate": {
      "title": "Log in to your Freshchat account",
      "sub_text": "Please provide a user account with global access",
      "token": "Freshchat Token",
      "host": "Freshchat host",
      "alignment": "Alignment",
      "right_down": "Right Down",
      "left_down": "Left Down",
      "customization": "For more customizations at an account level, please",
      "advanced_settings": "click here for advanced settings.",
      "background": "Background",
      "foreground": "Foreground",
      "placeholders": {
        "token": "Enter your Freshchat token",
        "host": "Enter your Freshchat host"
      }
    }
  },
  "drift": {
    "title": "Drift",
    "sub_text": "Integrate Drift to manage conversations with customers",
    "deactivate_slider": {
      "title": "Driftchat",
      "sub_text": "Upon deactivation, analytics will not displayed in Drift."
    },
    "activate": {
      "title": "Log in to your Drift chat account",
      "sub_text": "Please provide a user account with global access",
      "drift_id": "Drift ID",
      "background": "Background",
      "foreground": "Foreground",
      "active": "Active",
      "text": "Text",
      "placeholder": {
        "drift_id": "Enter your Drift ID",
        "welcome_message": "Please describe the welcome message",
      }
    },
    "customization": " For more customizations at an account level, please",
    "advanced_settings": "click here for advanced settings.",
    "load_error": "Please provide a valid load number"
  },
  "google_analytics": {
    "title": "Google Analytics",
    "sub_text": "Integrate with Google Analytics (Universal Analytics) to track shared links (ineffective from July 1, 2023)",
    "deactivate_slider": {
      "title": "Google Analytics",
      "sub_text": "Upon deactivation, analytics will not displayed in Google Analytics."
    },
    "activate": {
      "title": "Activate your Google Analytics account",
      "sub_text": "Please provide a user account with global access",
      "tracking_id": "Tracking Id",
      "placeholder": "Enter your tracking id",
      "error": "Please provide a valid apiKey"
    }
  },
  "google_anaytics_v4": {
    "title": "Google Analytics 4",
    "sub_text": "Integrate for Google Analytics 4 to track shared links",
    "deactivate_slider": {
      "title": "Google Analytics 4",
      "sub_text": "Upon deactivation, analytics will not displayed in Google Analytics."
    },
    "activate": {
      "title": "Activate your Google Analytics 4 account",
      "sub_text": "Please provide a user account with global access",
      "tracking_id": "Tracking Id",
      "placeholder": "Enter your tracking id",
      "error": "Please provide a valid apiKey"
    }
  },
  "google_tag_manager": {
    "title": "Google Tag Manager",
    "sub_text": "Integrate for Google to track Tag level analytics",
    "deactivate_slider": {
      "title": "Google Tag Manager",
      "sub_text": "Upon deactivation, analytics will not displayed in Google Tag Manager"
    },
    "activate": {
      "title": "Activate in to your Google Tag Manager account",
      "sub_text": "Please provide a user account with global access",
      "api_key": "API KEY",
      "placeholder": "Enter your api key",
      "error": "Please provide a valid apiKey"
    }
  },
  "fire_flies": {
    "title": "Fire Flies",
    "sub_text": "Integrate with Fire Flies to track Tag level analytics",
    "deactivate_slider": {
      "title": "Fire Flies",
      "sub_text": "Upon deactivation, analytics will not displayed in Fire Flies"
    },
    "activate": {
      "title": "Activate your Fire Flies account",
      "sub_text": "Please provide a user account with global access",
      "api_key": "API KEY",
      "placeholder": "Enter your api key",
      "error": "Please provide a valid apiKey"
    }
  },
  "six_sense": {
    "title": "Six Sense",
    "sub_text": "Integrate for Six Sense to track shared links",
    "deactivate_slider": {
      "title": "Six Sense",
      "sub_text": "Upon deactivation, analytics will not displayed in Six Sense."
    },
    "activate": {
      "title": "Activate your Six Sense account",
      "sub_text": "Please provide a user account with global access",
      "api_key": "API KEY ",
      "placeholder": "Enter your api key",
      "error": "Please provide a valid apiKey"
    }
  },
  "zoho": {
    "title": "Zoho",
    "sub_text": "Integrating Paperflite with Zoho enables sales reps to nurture their prospects at every stage of the buyer's journey with contextual content. It helps sales reps know how their prospects are engaging with their content, i.e., number of views, downloads, re-shares etc.",
    "loading": "Loading Zoho configuration",
    "activate": {
      "title": "Log into your Zoho account",
      "sub_text": "A secure Zoho account authorization window will <br />open when you click authenticate below"
    },
    "error_messages": {
      "instance_url": "Please provide a valid instance url",
      "token_expired": {
        "title": "Log in to your Zoho account",
        "sub_text": "Your authentication to Zoho has expired and needs to be re-authenticated.",
        "non_admin":"Please contact your admin to renew authentication",
      },
    },
    "active": "Zoho integration is currently active for this email account",
    "empty_message": {
      "title": "Halt! Road closed ahead.",
      "sub_text": "You don't have access to zoho yet. Get in touch with your Paperflite administrator to integrate with zoho."
    },
    "deactivate_slider": {
      "title": "Zoho",
      "sub_text": "Upon deactivation, analytics will not displayed in Zoho"
    },
    "expired": {
      "title": "Your Zoho integration has expired.",
      "sub_text": "Please re-authenticate."
    },
    "configuration": {
      "sync": {
        "title": "Sync events",
        "sub_text": "Configuration for the events to publish to zoho",
        "events": {
          "create_lead": "Create a Lead",
          "view_asset": "Contact/Lead views an Asset",
          "view_asset": "Contact/Lead views a collection",
          "reshare_collection": "Contact/Lead reshares a collection",
          "download_asset": "Contact/Lead downloads an asset"
        }
      }
    }
  },
  "ms_dynamics": {
    "title": "Microsoft Dynamics",
    "sub_text": "Connecting MS Dynamics with Paperflite arms sales teams with all the intelligence to move deals faster and improve deal win rates by providing high-performing content recommendations right within their workflow.",
    "url_error": "Please provide a valid instance url",
    "loading": {
      "config": "Loading msDynamics configuration",
      "override": "Loading msDynamics override configuration"
    },
    "instance_url": "Instance URL",
    "placeholder": "Enter your domain url",
    "activate": {
      "title": "Log into your Microsoft Dynamics account",
      "sub_text": "A secure Microsoft Dynamics account authorization window will <br />open when you click authenticate below"
    },
    "error_messages": {
      "instance_url": "Please provide a valid instance url",
      "token_expired": {
        "title": "Log in to your MsDynamics account",
        "sub_text": "Your authentication to MsDynamics has expired and needs to be re-authenticated.",
        "non_admin":"Please contact your admin to renew authentication",
      },
      "expired": "The authentication to MsDynamics has expired for the Admin and needs to be re-authenticated.",
      "click_here": "Click here",
      "to_authenticate": "To authenticate",
      "session_expired_secondary": "Your overridden configuration has expired. Please {0} to re-authenticate. Note: Until you re-authenticate, the integration will function as per the admin’s configuration.",
      "session_expired": "Your session has expired. You are currently connected to “{primaryEmail}”. In order to override your account, please {0}"
    },
    "deactivate_slider": {
      "title": "MS Dynamics",
      "sub_text": "Deactivating this integration will disconnect Paperflite and MS Dynamics for ALL users."
    },
    "toast": "MS Dynamics shared fields updated successfully",
    "active": "MsDynamics integration is currently active for this instance.",
    "active_email": "MsDynamics integration is currently active for this email account.",
    "help_text": "Make custom fields from MS Dynamics for an opportunity available within Paperflite",
    "configuration": "Configuration for the events to publish to MsDynamics",
  },
  "salesloft": {
    "title": "Salesloft",
    "sub_text": "Integrate salesloft CRM to sync events across leads & contacts",
    "loading": "Loading salesloft configuration",
    "activate": {
      "title": "Log into your Salesloft account",
      "sub_text": "A secure Salesloft account authorization window will <br />open when you click authenticate below"
    },
    "deactivate_slider": {
      "title": "Salesloft",
      "sub_text": "Upon deactivation, analytics will not displayed in Salesloft."
    },
    "active": "Salesloft integration is currently active for this email account.",
    "config": "Configuration for the events to publish to salesloft",
    "empty_message": {
      "title": "Halt! Road closed ahead.",
      "sub_text": "You don't have access to Salesloft yet. Get in touch with your Paperflite administrator to integrate with Salesloft."
    }

  },
  "allocadia": {
    "title": "Allocadia",
    "sub_text": "Integrate your Allocadia with Paperflite account to manage offers.",
    "loading": "Loading Allocadia configuration",
    "data_center": "Data Center",
    "user_name": "User Name",
    "password": "Password",
    "change_password": "Change Password",
    "placeholder": {
      "data_center": "Select data center",
      "user_name": "Enter your user name",
      "password": "Enter your password",
    },
    "deactivate_slider": {
      "title": "Allocadia",
      "sub_text": "Upon deactivation, mails will no longer be sent from your email id"
    },
    "error_messages": {
      "crendentials": "Credentials are incorrect",
      "username": "Please provide a valid user name",
      "password": "Please provide a valid password",
    }
  },
  "marketo": {
    "title": "Marketo",
    "sub_text": "Integrate with Marketo to sync events across contacts",
    "loading": "Loading Marketo configuration",
    "client_id_placeholder": "Enter your Client Id",
    "client_secret_placeholder": "Enter your Client Secret",
    "munchkin_id": "Munchkin Id",
    "client_id": "Client Id",
    "client_secret": "Client Secret",
    "munchkin_id_placeholder": "Enter your Munchkin Id",
    "configuration": "Configuration for the events to publish to Marketo",
    "activate": {
      "title": "Activate in to your Marketo account",
      "sub_text": "A secure Marketo account authorization window will <br />open when you click authenticate below"
    },
    "deactivate_slider": {
      "title": "Marketo",
      "sub_text": "Upon deactivation, analytics will not displayed in Marketo."
    },

    "error_messages": {
      "failed_to_update": "Unable to update Marketo integration",
      "munchkin_id": "Please provide a valid Munchkin id",
      "client_id": "Please provide a valid Client Id",
      "client_secret": "Please provide a valid Client Secret",
    }
  },
  "slack": {
    "title": "Slack",
    "sub_text": "Our integration with Slack brings real-time prospect engagement notifications directly to your team's channels within Slack. Stay informed seamlessly without missing a beat.",
    "activate": {
      "title": "Log into your Slack account",
      "sub_text": "A secure slack account authorization window will <br/> open when you click authenticate below"
    },
    "expired": "Your Slack integration has expired.",
    "active": "Slack integration is currently active on {name} workspace",
    "deactivate_slider": {
      "title": "Slack",
      "sub_text": "Upon deactivation, your will no longer receive notifications from Paperflite via Slack."
    }
  },
  "external_scripts": {
    "title": "External Script",
    "sub_text": "This integration will give you the ability to add custom scripts to embed widgets, integrate third party apps or design specific organisation inputs into Fliteview",
    "error_message": "Please provide a valid script",
    "editor": "External Script Editor",
    "deactivate_slider": {
      "title": "External Script",
      "sub_text": "Upon deactivation, External Script will be deactivated."
    }
  },
  "pardot": {
    "title": "Pardot",
    "sub_text": "Our integration with Pardot helps you enhance your marketing efforts, automate lead nurturing, and gain valuable insights into the effectiveness of your content",
    "loading": "Loading Pardot configuration",
    "pardot_business_unit_id": "Pardot Business Unit ID",
    "placeholder": "Enter your Pardot Business Unit Id",
    "config": "Configuration for the events to publish to pardot",
    "activate": {
      "title": "Log into your Pardot account",
      "sub_text": "A secure Pardot account authorization window will <br />open when you click authenticate below"
    },
    "deactivate_slider": {
      "title": "Pardot",
      "sub_text": "Upon deactivation, analytics will not displayed in Pardot."
    },
    "active": "Pardot integration is currently active for this email account",
    "empty_message": {
      "title": "Halt! Road closed ahead.",
      "sub_text": "You don't have access to Pardot yet. Get in touch with your Paperflite administrator to integrate with Pardot."
    },
    "expired": {
      "title": "Your Pardot integration has expired.",
      "sub_text": "Please re-authenticate."
    },
  },
  "netsuite": {
    "title": "Netsuite",
    "sub_text": "Integrate netsuite CRM to sync events across leads & contacts",
    "loading": {
      "config": "Loading Netsuite configuration",
      "override": "Loading Netsuite override configuration"
    },
    "client_id": "Client Id",
    "client_secret": "Client Secret",
    "account_id": "Account Id",
    "active": "Netsuite integration is currently active for this instance.",
    "active_email": "Netsuite integration is currently active for this email account.",
    "config": "Configuration for the events to publish to Netsuite",
    "error_messages": {
      "client_id": "Please provide a valid Client Id",
      "client_secret": "Please provide a valid Client Secret"
    },
    "activate": {
      "title": "Log into your Netsuite account",
      "sub_text": "A secure Netsuite account authorization window will <br />open when you click authenticate below"
    },
    "deactivate_slider": {
      "title": "Netsuite",
      "sub_text": "Deactivating this integration will disconnect Paperflite and Netsuite for ALL users."
    },
    "active": "Netsuite integration is currently active for this email account",
    "empty_message": {
      "title": "Halt! Road closed ahead.",
      "sub_text": "You don't have access to Netsuite yet. Get in touch with your Paperflite administrator to integrate with Netsuite."
    }

  },
  "toast": {
    "smtp": "SMTP integration updated successfully",
    "freshsales": "Freshsales integration updated successfully",
    "pipedrive": "Pipedrive integration updated successfully",
    "klenty": "Klenty integrated successfully",
    "zoho": "Zoho integration updated successfully",
    "ms_dynamics": "MsDynamics integration updated successfully",
    "salesloft": "Salesloft integration updated successfully",
    "allocadia": "Allocadia integration created successfully",
    "marketo": "Marketo integration updated successfully",
    "pardot": "Pardot integration updated successfully",
    "netsuite": "Netsuite integration updated successfully",
    "salesforce": "Salesforce integration updated successfully",
    "hubspot": "HubSpot integration updated successfully",
    "outreach": "Outreach integration updated successfully",
  }
};

